// /assets/ts/utils/validators.ts


const specialChar = /[^\p{L}\p{Nd}]/u;

export interface PasswordValidationResult {
    isValid: boolean;
    rules: {
        minLength: boolean;
        lowercase: boolean;
        uppercase: boolean;
        specialChar: boolean;
        number: boolean;
        noRepeats: boolean;
        doesNotContainsUsername: boolean;
    };
}

export const checkPasswordRules = (username: string, password: string): PasswordValidationResult => {
    let isValid = false;
    const rules: PasswordValidationResult['rules'] = {
        minLength: false,
        lowercase: false,
        uppercase: false,
        specialChar: false,
        number: false,
        noRepeats: false,
        doesNotContainsUsername: false,
    };

    if (!password) return {isValid, rules};

    let lastChar: string | undefined;
    let repeatCount = 0;
    let hasRepeats = false;

    for (const char of password) {
        if (!rules.lowercase && char.toLowerCase() === char && char.toUpperCase() !== char) rules.lowercase = true;
        if (!rules.uppercase && char.toUpperCase() === char && char.toLowerCase() !== char) rules.uppercase = true;
        if (!rules.number && char >= '0' && char <= '9') rules.number = true;
        if (!rules.specialChar && specialChar.test(char)) rules.specialChar = true;

        if (!hasRepeats) {
            if (lastChar && char === lastChar) repeatCount++;
            else repeatCount = 1;
            lastChar = char;
            if (repeatCount >= 3) hasRepeats = true;
        }
    }

    if (password.length >= 8) rules.minLength = true;
    rules.noRepeats = !hasRepeats;

    rules.doesNotContainsUsername = !password.toLocaleLowerCase().includes(username.toLocaleLowerCase());

    isValid = rules.minLength && rules.lowercase && rules.uppercase && rules.number && rules.specialChar && rules.noRepeats && rules.doesNotContainsUsername;

    return {isValid, rules};
};